module.exports = __webpack_public_path__ + "img/202602_09.cb0b43c0.png";